import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { bindActionCreators } from 'redux'
import { ShootTracker } from 'actions/Tracker'
import {
  fetchNews,
  fetchCategories,
  fetchNewsByCategory,
} from 'actions/PublicNews'
import InfoBerita from 'components/publicPages/infoBerita'
import Cookies from 'js-cookie'

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => ({
  fetchNews: bindActionCreators(fetchNews, dispatch),
  fetchCategories: bindActionCreators(fetchCategories, dispatch),
  fetchNewsByCategory: bindActionCreators(fetchNewsByCategory, dispatch),
  ShootTracker: bindActionCreators(ShootTracker, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', false),
  withState('data', 'setData', {}),
  withState('categories', 'setCategories', {}),
  withState('pengumuman', 'setPengumuman', {}),
  withState('currentPage', 'setCurrentPage', 1),
  withState('pageTracker', 'setPageTracker', {}),
  withState('helpCenterTracker', 'setHelpCenterTracker', {}),
  withHandlers({
    getPageTracker: (props) => async () => {
      const { setPageTracker } = props
      const previous_page_name = Cookies.get('page_name')
      Cookies.set('page_name', 'NEWS_PAGE', {
        path: '',
        sameSite: 'strict',
        secure: true,
      })

      try {
        const res = await props.ShootTracker('visit_page', {
          key: 'previous_page_name',
          value: previous_page_name,
        })
        setPageTracker(res)
      } catch (err) {
        setPageTracker({})
      }
    },
  }),
  withHandlers({
    clickHelpCenter: (props) => async () => {
      const { setHelpCenterTracker } = props
      try {
        const res = await props.ShootTracker('click_help_center')
        setHelpCenterTracker(res)
      } catch (err) {
        setHelpCenterTracker({})
      }
    },
  }),
  withHandlers({
    getList: (props) => async (params) => {
      const { setData, setIsLoading } = props
      setIsLoading(true)
      try {
        const res = await props.fetchNews(params)
        setData({
          list: res.data,
          meta: res.meta,
        })
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  withHandlers({
    getCategoryList: (props) => async (params) => {
      const { setCategories } = props
      try {
        const res = await props.fetchCategories(params)
        setCategories(res.data)
      } catch (err) {
        console.log(err)
      }
    },
  }),
  withHandlers({
    getListPengumuman: (props) => async (params) => {
      const { setPengumuman } = props
      try {
        const res = await props.fetchNewsByCategory(params)
        setPengumuman(res.data)
      } catch (err) {
        console.log(err)
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getPageTracker()
      this.props.getList(`?limit=6&status=active`)
      this.props.getCategoryList(`?status=active`)
      this.props.getListPengumuman(
        `?category=e1263f32-c56a-4122-b438-243753df6164&limit=3&status=active`,
      )
    },
  }),
)(InfoBerita)
